var _rect, _rect2, _g, _rect3, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDevelop(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 89,
    height: 60,
    viewBox: "0 0 89 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 89,
    height: 60,
    fill: "#F5F5F5"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 7635,
    transform: "translate(-815 -3598)",
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_0_1)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 45,
    cy: 30,
    r: 89,
    stroke: "#8296A2",
    strokeWidth: 30,
    shapeRendering: "crispEdges"
  }))), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 89,
    height: 60,
    fill: "url(#pattern0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_0_1",
    x: -63,
    y: -74,
    width: 216,
    height: 216,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_0_1"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_0_1",
    result: "shape"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_0_1",
    transform: "scale(0.011236 0.0166667)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_0_1",
    width: 89,
    height: 60,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFkAAAA8CAYAAAANMhZGAAAFEElEQVR4nO2bP0wbVxzHv4n/U+dsl0M22EcsJS20uGqTZnKHVp0gA3TDnbrB1KoLkfpvKlNZErVLsqULXkklHKljZZQqlRopplGaUAWfAVscwucaY/CZdsA2tu98xpB7dw7vs/nnx/mnj5++9947c8713of/gaIZH7z/Ls7r3cRZgEomAJVMAHNzgRu+qkcfrwwuhwWJP39vqNGZ/JKx2ayymmwmn1Um3trE+NtC7fW9v1gsPOnDl5/xDeNu3uUwYV3HuG3taOyeHwv7Ay2vTSVXGGD2cM2fq73+I3UBAPDGxV35WNMurpm3j8ZKr6tem8YFAahkAtC4qLDwpA8P15ja6/WcDQBw8+eAfOzeAB6WPEdjDxyq16aSK6znbDWx9Tx70SMfe+BoK7YemWTX2McdtkeWslTCeUnSu42W7Isi8OC3hppM8rPgILGGToK/VASfL+jdRksCnguyGr3xEYBKJgCVTAAqmQBUMgGoZAJ05WaE67HjpyvDDbVELo9vHj/XqSN1ulLy9X4WYdbdUItvZXXqpj1dGRefcj5ZbT6Z1qGT49F1kgfsNoy4nA21ZTEPvlDUqaP2dJ3kj/o8sto8b9xZDHSh5PEBVlZb3BAURhqHrpLM2a1409l49Gj0qAAMJDni9WD2UuuHkQAw1svIas1RwfXYMX0pAJfFOAsnXTvh7FZEvB5M+VkwZhOWxB3V8RGf/IFlc1QM9tgxG7qMG0NBLKYF3F5JISHmX2rfnaKL5LDbiYjXg0mv/CbWipDTgZHX7A01tahgLGZEOB8inA9LQhbzfBpRnZZ5xCS7zCaM9TKYuehFwC7/AUg7IgpfyHFXFWHWjTDrxo2hIKJ8GvPJNNEc11wyZ7di2s9i0usBYzad+DpKedzpqoLrsWNmKIiZiuxoMo24oP1OUTPJYbcT034Wowpymrm/lUNMEBHNbCu+H3I6ZLO/VVTEhSw+iT9CZNCH6z4WTIsbYDVK+EIRPzx9gdiGALGkzbNDTSTfHQm2lbu8U8Sd1CZiWzmIUll1bKdREReyiAtZfI7Dc46xfhYRha04cDi7f7wyjFxIwkT8kSY3SU0kt4qFVHEf0cw2oplt8MX9Y1/vNFGxuCFgcUPAt4+fY6yfPZTuk29oGItZs2UfsRtfqriPudXMsWZuPZ1EhRpiSaplcELMY2Yo2NHfnwZikgN2K24NcbiFowzWIiqUcFnMqrNYazSRPLeaUV0Hj/YyGO1l8L1URqxOuBKniYp2eVxPlE8jqdGyThPJS9k8lrL5muzqjq4ZxmzCZOXLyEll3FkTMLeaqb2vFBV/5wuqUeGymDH7zmXVlUUVvlAksm7WNC74Sg7XZAf6ZLu2KozZhLDbCdRJVoqKe+vqszjkcraduaR3gMQyubqqCDkdmKpsTtqhFBW/bGye6PNzJUm3swziZxeJ/C6+eMrju5V1TPlZRLwexW22UlTc38rh3w5WJsBhJNz+J4VoMq3ZZqMdup3CiVK5IUomm07YlKIiJojHvn4sLSCaTBviQN8Qh67VKOHqZq5SVMS2cnDKqo0kxDyu/vrAUAf5hpBcpboLbBUVolRuK1ksSbrFQisM82SkntNGhdEw1EyuEs1sY7Fpc7Kcl/+rV7dgSMmJLhaqhCHj4lWDSiYAlUwAKpkAVDIBqGQCUMkEkK2TAwV9f9LUjnM7eQQODvRuoyVSak1Wk0le+eprIs2cJWhcEIBKJgCVTID/AQMv7DFkKwr2AAAAAElFTkSuQmCC"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDevelop);
export default __webpack_public_path__ + "static/media/develop.08946ef42d575d661bde1e7d4d5952c2.svg";
export { ForwardRef as ReactComponent };